import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { isMobileOnly } from "react-device-detect";
import dayjs from "dayjs";
import ptBr from "date-fns/locale/pt-BR";
import { registerLocale } from "react-datepicker";

import { InputContainer } from "./styles";

registerLocale("pt-BR", ptBr);

export function DatePickerInput({
	label,
	value,
	onChange,
	placeholder,
	error,
	onBlur,
	...props
}) {
	const [selectedDate, setSelectedDate] = useState(null);

	useEffect(() => {
		if (value) {
			const date = dayjs(value);
			if (date.isValid()) {
				setSelectedDate(date.toDate());
			}
		}
	}, [value]);

	const handleChange = date => {
		setSelectedDate(date);
		if (onChange) {
			onChange(date);
		}
	};

	const handleBlur = () => {
		if (onBlur) {
			const formattedDate = dayjs(selectedDate).isValid()
				? dayjs(selectedDate).format("DD/MM/YYYY")
				: "";
			onBlur(formattedDate);
		}
	};

	return (
		<InputContainer>
			<label htmlFor={label}>{label}</label>
			<DatePicker
				selected={selectedDate}
				onChange={handleChange}
				onBlur={handleBlur}
				dateFormat="dd/MM/yyyy"
				locale="pt-BR"
				placeholderText={placeholder || "Ex: 01/01/1970"}
				dropDownMode="select"
				popperPlacement="center"
				withPortal={isMobileOnly}
				className="form__form-group-datepicker"
				{...props}
			/>
			{error && <span className="form__form-group-error">{error}</span>}
		</InputContainer>
	);
}
